export type NfseStatus =
  | "NaoIniciada"
  | "EmPreparacao"
  | "EmissaoSolicitada"
  | "Autorizada"
  | "Rejeitada"
  | "FalhaIntegracao"
  | "PendenteCorrecao"
  | "EmReprocessamento"
  | "CancelamentoSolicitado"
  | "Cancelada"
  | "EnviadaPorEmail"
  | "FalhaEnvioEmail"
  | "Reenviada";

export const NFSE_STATUS_LABEL: Record<NfseStatus, string> = {
  NaoIniciada: "Não iniciada",
  EmPreparacao: "Em preparação",
  EmissaoSolicitada: "Emissão solicitada",
  Autorizada: "Autorizada",
  Rejeitada: "Rejeitada",
  FalhaIntegracao: "Falha na integração",
  PendenteCorrecao: "Pendente de correção",
  EmReprocessamento: "Em reprocessamento",
  CancelamentoSolicitado: "Cancelamento solicitado",
  Cancelada: "Cancelada",
  EnviadaPorEmail: "Enviada por e-mail",
  FalhaEnvioEmail: "Falha no envio por e-mail",
  Reenviada: "Reenviada",
};
